import {Injectable} from '@angular/core';
import {HttpRequestService } from '../../shared/services/http-request.service';
import 'rxjs/add/operator/map';
import {environment} from '../../../environments/environment';
import {GridService} from '../../shared/services/grid.service';

@Injectable()
export class PushMessageDatabaseService extends GridService {
  private getPushMessagesURL = environment.apiUrl + '/PushMessageCms/GetPushMessages';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getPushMessages;
  }

  getPushMessages(data) {
    return this._http.post(this.getPushMessagesURL, data);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-messages-database/push-message-database.service.ts